/**
* @GpsTable.vue
* @Description GPS标签管理组件
* @Author CC
* @Date 2025/09/20
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   class="dialog_title"
                   @close="handleDialogClose"
        >
        <div class="table-item-box padding-l-none">
            <section style="height: 100%;">
                <!--查询工具条-->
                <el-col style="padding-bottom: 0px;text-align: left;padding-bottom: 10px;">
                    <el-form :inline="true" :model="filters" ref="filters">
                        <el-form-item>
                            查询条件：
                        </el-form-item>
                        <el-form-item prop="time">
                            <el-date-picker
                                :picker-options="filters.pickerOptions"
                                v-model="filters.time"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期"
                            >
                            </el-date-picker>
                        </el-form-item>
<!--                        <el-form-item prop="packageType" v-if="filters.packageTypeStatus">
                            <el-select v-model="filters.packageType" placeholder="请选择包类型" clearable @change="searchGpsTagLog">
                                <el-option v-for="(value, key) in mts" :key="key" :label="value" :value="key"></el-option>
                            </el-select>
                        </el-form-item>-->
                        <el-form-item>
                            <el-button icon="el-icon-search" type="info" size="mini" trigger="click" @click="searchGpsTagLog"> 查询</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!-- 表格 -->
                <el-table :data="logs"
                          @sort-change="changeSort"
                          ref="multipleTable"
                          stripe
                          style="width: 100%;"
                          :class="{'table': true, 'no-pagination': false}">
                    <el-table-column label="序号" type="index" width="60px">
                        <template v-slot="scope">
                            {{ scope.$index + 1}}
                        </template>
                    </el-table-column>
                    <el-table-column label="远程地址" min-width="150px">
                        <template v-slot="scope">
                            <span style="white-space: nowrap;">
                                {{scope.row.clientAddr}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="上传时间" min-width="150px">
                        <template v-slot="scope">
                            <span style="white-space: nowrap;">
                                {{$moment(scope.row.uploadTime).format('YYYY-MM-DD HH:mm:ss')}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="接收时间" min-width="150px">
                        <template v-slot="scope">
                            <span style="white-space: nowrap;">
                                {{$moment(scope.row.serverTime).format('YYYY-MM-DD HH:mm:ss')}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="处理时间" min-width="80px">
                        <template v-slot="scope">
                            <span style="white-space: nowrap;">
                                {{ (scope.row.dealTime - scope.row.serverTime) + " ms"}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="完成时间" min-width="150px">
                        <template v-slot="scope">
                            <span style="white-space: nowrap;">
                                {{$moment(scope.row.dealTime).format('YYYY-MM-DD HH:mm:ss')}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="协议类型" min-width="80px" v-if="filters.packageTypeStatus">
                        <template v-slot="scope">
                            <span style="white-space: nowrap;">
                                {{ scope.row.protocolNo}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="包类型" min-width="80px">
                        <template v-slot="scope">
                            <span style="white-space: nowrap;">
                                {{ mts[scope.row.packageType]}}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="详情" width="60px">
                        <template v-slot="scope">
                            <span style="white-space: nowrap;cursor: pointer;text-decoration:underline;"
                                  :title="scope.row.did" @click="logDetail(scope.row, scope.$index)">
                                详情
                            </span>
                        </template>
                    </el-table-column>
                </el-table>

                <GpsTagLogDialog ref = "gpsTagLogDialog"/>

            </section>
        </div>
    </el-dialog>
    </div>
</template>

<script>
// gps标签组件
import ApiGpsTag from '@/request/api-gps-tag'
import GpsTagLogDialog from './GpsTagLogDialog'

export default {
    /**
     * 组件名称
     */
    name: "GpsTagLogTable",
    /**
     * 组件引用
     */
    components: {
        GpsTagLogDialog
    },
    /**
     * 数据定义
     * @returns {{}}
     */
    data() {
        return {
            /**
             * @Des 弹出层属性
             * @Auth CC
             * @Date 2025/09/20
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            /**
             * @Des 查询条件属性
             * @Auth CC
             * @Date 2025/09/20
             */
            filters: {
                // 开始时间 - 结束时间
                did: '',
                packageType: "",
                packageTypeStatus: false,
                time: '',
                beginTime: 0,
                endTime: 0,
                // 隐藏的时间
                pickerOptions: {
                    disabledDate(v) {
                        return v.getTime() > new Date().getTime()
                    }
                },
                orderBy: {
                    "server_time": 'desc',
                },
                sortOrders: [
                    "ascending",
                    "descending"
                ],
                sortable: 'custom',
                locked: false,
            },
            // 日志集合
            logs:[],
            mts: {
                "01": "产测包",
                "02": "心跳包",
                "03": "登录包",
                "05": "命令包",
                "07": "定位包",
                "08": "报警包",
                "09": "健康信息包",
                "0A": "环境信息包",
                "10": "配置包",
                "11": "配置请求包",
                "12": "响应包",
                "13": "离线包",
                "14": "注册包",
                "15": "LBS包",
                "16": "通话记录",
                "4F01": "GPS包",
                "4F05": "配置包",
                "4F06": "消息ID",
                "4F07": "基站定位",
                "4F08": "GPS定位",
                "4F09": "开机基站定位",
                "4F10": "LBS/WIFI定位",
                "4F11": "固定报警",
                "4F12": "计步",
            }
        }
    },
    /**
     * 方法定义
     */
    methods: {

        openDialog(title, row, index){
            this.dialogTreeItem.title = title;
            this.filters.packageType = "";
            this.filters.did = row.did;
            if(row.type != '01' && row.type != '02' && row.type != '03' && row.type != '05') {
                this.filters.packageTypeStatus = true;
            }else{
                this.filters.packageTypeStatus = false;
            }
            this.setToday();
            this.dialogTreeItem.dialogFormVisible = true;
            this.searchGpsTagLog();
        },

        setToday(){
            const now = new Date();
            this.filters.endTime = now.getTime();
            now.setHours(0, 0, 0, 0);
            this.filters.beginTime = now.getTime();
            this.filters.time = this.$moment(this.filters.beginTime).format('YYYY-MM-DD');
        },

        /**
         * @Description
         * @Param 查询gps标签
         * @Auth CC
         * @Date 2025/09/20
         */
        searchGpsTagLog() {
            // console.log(this.filters.time)
            if(this.filters.time == '' || this.filters.time == null){
                this.setToday();
            }else{
                this.filters.beginTime = Date.parse(this.filters.time + " 00:00:00");
                this.filters.endTime = Date.parse(this.filters.time + " 23:59:59");
            }
            if(this.locked) return;
            this.locked = true;
            let loading = this.$loading({
                lock: true,
                text: '数据加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            this.$request.postJsonRequest(ApiGpsTag.searchGpsTagLogApi, {
                did: this.filters.did,
                packageType: this.filters.packageType,
                beginTime: this.filters.beginTime,
                endTime: this.filters.endTime,
            }).then(result => {
                this.locked = false;
                loading.close();
                // console.log(result)
                this.logs = Object.assign([], []);
                if(result.total > 0){
                    this.logs = result.rows;
                }
            }).catch(error => {
                this.locked = false;
                loading.close();
                console.log( "查询GNSS日志异常：" + this.$request.error.msg);
            })
        },
        /**
         * @Des 弹窗关闭
         * @Auth CC
         * @Date 2025/09/20
         */
        handleDialogClose() {
        	// 日志集合
        	this.logs = Object.assign([], []);
            this.dialogTreeItem.dialogFormVisible = false;
        },
        /**
         * @Description
         * @Param 是否选择
         * @Auth CC
         * @Date 2025/09/20
         */
        checkSelectable(row){
            return true;
        },
        /**
         * @Description
         * @Param 改变排序
         * @Auth CC
         * @Date 2025/09/20
         */
        changeSort(data) {
            let prop = data.prop;
            let order = data.order;
            if (order == null) {
                order = this.filters.orderBy[prop];
            } else {
                order = order.replace("ending", "");
            }
            if (order == null) {
                this.filters.orderBy["sid"] = "asc";
            } else {
                this.filters.orderBy = {};
                this.filters.orderBy[prop] = order;
            }
            // console.log(this.filters.orderBy)
            this.searchGpsTagLog();
        },

        logDetail(row, index){
            this.$refs.gpsTagLogDialog.openDialog('【' + row.did + '】的设备日志详情【' + this.mts[row.packageType] + '】', row, index);
        }

    }
}
</script>

/* CSS */
<style lang="scss" scoped>
    /deep/ .el-dialog {
        width: 90%;
    }
    /deep/ .condition-form-item .el-form-item__label{
        line-height: 30px;
    }
    /deep/ .condition-form-item .el-form-item__content{
        line-height: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components_outdoor/Device/GpsTagLogTable.vue